document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".fixed_cart").addEventListener("click", function () {
    document.querySelector(".fixed_cart_detail").classList.add("fixed_cart_detail_show");
  });

  document.querySelector(".close_icon").addEventListener("click", function () {
    document.querySelector(".fixed_cart_detail").classList.remove("fixed_cart_detail_show");
  });




  const dispFloatingButton = () => {
    const watchElement = document.getElementById('AddToCart-product');
    console.log(watchElement);
    const floatingAddToCart = document.getElementById("floatingAddToCartArea");
    var rect = watchElement.getBoundingClientRect();
    if (rect.bottom < 140) {
      // watchElementが画面外になった場合
      floatingAddToCart.classList.add("is-visible");
    } else {
      // watchElementが画面内に存在する場合
      floatingAddToCart.classList.remove("is-visible");
    }
  }
  window.addEventListener("DOMContentLoaded", dispFloatingButton);
  window.addEventListener("scroll", dispFloatingButton);


});